<template>
    <div class="col-12 d-flex">
        <div class="footer px-4 py-4 text-left col-6">
            <router-link :to="{ name: 'Terms' }" target= '_blank'>
                <p>Terms & Conditions</p>
            </router-link>
            <router-link :to="{ name: 'Privacy' }" target= '_blank'>
                <p>Privacy Policy</p>
            </router-link>
            <router-link :to="{ name: 'AccessibilityStatement' }" target= '_blank'>
                <p>Accessibility Statement</p>
            </router-link>
        </div>
        <div class="footer px-4 py-4 text-left col-6">
            <router-link :to="{ name: 'Cookies' }" target= '_blank'>
                <p>Cookie Policy</p>
            </router-link>
            <router-link :to="{ name: 'Sitemap' }" target= '_blank'>
                <p>Site Map</p>
            </router-link>
        </div>
        <div v-if="this.brand === 'raigmore'" class="col-6  px-4 py-4 d-flex justify-content-end pr-4">
            <a class="powered-by" href="https://www.fusemobility.co.uk/" target="_blank">
                <p>Powered by <svg-icon aria-labelledby="fuse logo" :name="this.brand + '/fuse_logo'" class="footer-icons"></svg-icon></p>
            </a>
        </div>
    </div>
</template>
<script>
const whitelabel = require('../../whitelabel.config')[process.env.VUE_APP_BRAND]

export default {
    data() {
        return {
            brand: whitelabel.brand,
        }
    },
}
</script>
